<template>
  <component :is="target ? 'router-link' : 'article'" v-if="variant === 'solution'" class="solution-card" :to="target || undefined">
    <img :src="image" :alt="item.title"><div><span class="card-meta">{{ indexLabel }} / {{ item.subtitle || item.categoryName || 'SOLUTION' }}</span><h3>{{ item.title }} <span v-if="target">↗</span></h3></div>
  </component>
  <component :is="target ? 'router-link' : 'article'" v-else-if="variant === 'case'" class="case-card" :to="target || undefined">
    <div class="image-wrap"><img :src="image" :alt="item.title"><span class="ai-label">{{ $t('card.showcase') }}</span></div>
    <div class="case-caption"><div><span class="card-meta">{{ item.categoryName || $t('card.case') }}</span><h3>{{ item.title }}</h3></div><span v-if="target">↗</span></div>
  </component>
  <component :is="target ? 'router-link' : 'article'" v-else class="product-card" :to="target || undefined">
    <div class="product-image"><img :src="image" :alt="item.title"><span v-if="target" class="card-arrow">↗</span></div>
    <div class="card-meta">{{ item.subtitle || item.categoryName || module }}</div><h3>{{ item.title }}</h3><p>{{ item.categoryName || item.summary }}</p>
  </component>
</template>

<script>
import { resolveAssetUrl } from '../api/public'
import { assets } from '../data/site'
export default {
  name: 'ContentCard',
  props: { item: { type: Object, required: true }, module: { type: String, required: true }, variant: { type: String, default: 'product' }, index: { type: Number, default: 0 } },
  computed: {
    image() { return resolveAssetUrl(this.item.coverImage, assets.hero) },
    indexLabel() { return String(this.index + 1).padStart(2, '0') },
    target() {
      if (this.item.id) return `/detail/${this.module.toLowerCase()}/${this.item.id}`
      if (this.item.detailSlug) return `/detail/${this.module.toLowerCase()}/${this.item.detailSlug}`
      return ''
    }
  }
}
</script>
